import React, { ReactNode, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { NavConfigType, SEODataType, NavAndFooterType } from "../global";
import CommonFooter from "./CommonFooter";
import CommonNavbar from "./CommonNavbar";
import Head from "./Head";

const CookieBar = dynamic(() => import("./CookieBar"));
const SurveyComponent = dynamic(() => import("./RatingAndReview/SurveyComponent"));

interface LayoutProps {
  children: ReactNode;
  cookieData: {};
  navConfig: NavConfigType;
  navFooter: NavAndFooterType;
  resources: {};
  seoData: SEODataType;
}

export default function Layout({ children, cookieData, navConfig, navFooter, resources, seoData }: LayoutProps) {
  const isSchemaPresent = Array.isArray(seoData?.schema) && seoData?.schema?.length > 0;
  const schemas = isSchemaPresent ? seoData?.schema : [];
  const bodySchemaMarkups = schemas.filter((schema) => schema.location === "body");

  const [delayFooter, setDelayFooter] = useState(false);
  const [delayCookieBar, setDelayCookieBar] = useState(false);
  const [delaySurvey, setDelaySurvey] = useState(false);
  const [delayNavbar, setDelayNavbar] = useState(false);

  useEffect(() => {
    const timer2 = setTimeout(() => {
      setDelayNavbar(true);
    }, 1000);

    const timer3 = setTimeout(() => {
      setDelayFooter(true);
    }, 5000);

    const timer4 = setTimeout(() => {
      setDelayCookieBar(true);
    }, 6000);

    const timer5 = setTimeout(() => {
      setDelaySurvey(true);
    }, 8000);

    return () => {
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
      clearTimeout(timer5);
    };
  }, []);

  return (
    <div>
      <Head seoData={seoData} />
      <noscript>
        <iframe
          title="google-tag-manager"
          src="https://www.googletagmanager.com/ns.html?id=GTM-KL29CZ4"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>

      {navFooter?.navbar && navConfig && !navConfig.remove_navbar && delayNavbar && (
        <CommonNavbar blok={navFooter?.navbar} config={navConfig} resources={resources} />
      )}
      {navFooter?.mob_navbar && navConfig && !navConfig.remove_mob_navbar && delayNavbar && (
        <CommonNavbar blok={navFooter?.mob_navbar} config={navConfig} resources={resources} />
      )}

      {navFooter?.mob_navbar && navConfig && !navConfig.remove_mob_navbar && <div className="h-14 sm:h-0" />}

      {children}

      {bodySchemaMarkups?.map(({ schema }) => (
        <body key={schema}>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: schema
            }}
          />
        </body>
      ))}

      {delayFooter && (
        <footer>
          {navFooter?.footer && navConfig && !navConfig.remove_footer && <CommonFooter blok={navFooter?.footer} />}
          {navFooter?.mob_footer && navConfig && !navConfig.remove_mob_footer && (
            <CommonFooter blok={navFooter?.mob_footer} />
          )}
        </footer>
      )}

      {delayCookieBar && <CookieBar cookieData={cookieData} />}
      {delaySurvey && <SurveyComponent />}
    </div>
  );
}
